/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, theme, convertHexToRGB, replacePXinStringWithEM} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE TABLE : STYLES --------------- ++++++++++ */
export default theme => ({
    table: {
        maxWidth: pxToEm(1280),
    },
    column: {
      flex: '1',
      flexWrap: 'nowrap',
      paddingRight: replacePXinStringWithEM(`5px`)
    },
    tablehead: {
        display: 'flex',
        background: theme.color.light.light.swatch,
        color: convertHexToRGB(theme.color.supporting.dark.swatch, 50),
        fontSize: pxToEm(12),
        fontWeight: '500',
        padding: replacePXinStringWithEM(`35px`),
        textAlign: 'left',
        paddingLeft: replacePXinStringWithEM(`45px`),
    },
    tablebody: {
        display: 'flex',
        flexDirection: 'column',
    },
    oddrow: {
        background: 'rgba(243, 249, 254, 0.6)',
        '& > td': {
            background: 'initial'
        }
    },
    tablerow: {
        display: 'flex',
        textAlign: 'left',
        padding: replacePXinStringWithEM(`25px`),
        paddingLeft: replacePXinStringWithEM(`35px`),
    },
    expandable: {
        display: 'flex',
    }
});
